export default "__VITE_ASSET__D5I6pNjA__"